import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-bg-deep border-t border-border-primary/50 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src="/images/logo-white.svg" alt="Dough" className="h-6" />
          <span className="text-text-tertiary text-sm">&copy; 2026 Dough</span>
        </div>

        <div className="flex items-center gap-6">
          <Link to="/privacy" className="text-text-tertiary hover:text-white text-sm transition-colors">
            Privacy
          </Link>
          <Link to="/terms" className="text-text-tertiary hover:text-white text-sm transition-colors">
            Terms
          </Link>
          <a href="mailto:help@betteryou.ai" className="text-text-tertiary hover:text-white text-sm transition-colors">
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
